export const PageHeader = ({ code, kicker, title, subtitle, testId = "page-header" }) => {
  return (
    <section data-testid={testId} className="px-6 md:px-12 lg:px-24 pt-20 md:pt-28 pb-12 md:pb-16 border-b border-white/10 relative overflow-hidden">
      <div className="absolute inset-0 stripes pointer-events-none opacity-60" />
      <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <div className="flex items-center gap-3 mb-5">
            <span className="font-mono-tech text-[11px] text-[#FF3B30] tracking-[0.3em]">{code}</span>
            <span className="h-px flex-1 max-w-[80px] bg-white/20" />
            <span className="font-mono-tech text-[11px] text-white/40 tracking-[0.3em] uppercase">{kicker}</span>
          </div>
          <h1 className="font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            {title}
          </h1>
        </div>
        <div className="md:col-span-4">
          <p className="text-white/65 text-base md:text-lg leading-relaxed">{subtitle}</p>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
